<template>
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs :setMenuId='myListMenuId' @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <!--Basic Info-->
        <div class="sub_tit mt10">{{ $t('SUBTITLE.GLOBAL.BASIC.INFO') }}</div>
        <!-- //Basic Info head -->
        <!-- detail_Basic Info -->
        <table class="create_table">
            <colgroup>
                <col width="13.5%">
                <col width="*">
                <col width="13.5%">
                <col width="*">
            </colgroup>
            <tbody>
                <tr>
                    <th>{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}<em class="txt_mandatory">*</em></th>
                    <td colspan="3" data-input-type="select">
                        <fieldset class="ui_fieldset set_2 input-58">
                            <div>
                                <select id="RHQ_CD" name="RHQ_CD"
                                        class="slt_white w100"
                                        v-model="RHQ_CD"
                                        @change="changeRhqCd($event)"
                                        v-validation="{ groupId: 'basic' }">
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                    <option v-for="(item, index) in rhqCdList" :key="item.code" :value="item.code">{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select id="CORP_NO" name="CORP_NO" class="slt_white w100"
                                        v-model="CORP_NO"
                                        @change="changeCorpCd($event)"
                                        v-validation="{ groupId: 'basic' }">
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                    <option v-for="(item, index) in corpCdList" :key="item.code" :value="item.code" >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.GLOBAL.CATEGORY') }}</th>
                    <td>
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="BOARD_TYPE1"
                                    name="BOARD_TYPE1"
                                    v-model="BOARD_TYPE1"
                                    class="slt_white w100"
                                    @change="changeBoardType1($event)"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                    <option v-show="boardType1List.length > 0"
                                            v-for="item in boardType1List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="BOARD_TYPE2"
                                    name="BOARD_TYPE2"
                                    v-model="BOARD_TYPE2"
                                    class="slt_white w100"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                    <option v-show="boardType2List.length > 0"
                                            v-for="item in boardType2List"
                                            :key="item.code"
                                            :value="item.code"
                                            :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </td>
                    <th>{{ $t('FIELD.ADMIN.MENU.ORDER') }}</th>
                    <td>
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="NEXT_ORDER1"
                                    name="NEXT_ORDER1"
                                    v-model="NEXT_ORDER1"
                                    class="slt_white w100"
                                    @change="changeOrder($event)"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.NEXT.OF') }}</option>
                                    <option v-show="nextOrder1List.length > 0"
                                            v-for="item in nextOrder1List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="NEXT_ORDER2"
                                    name="NEXT_ORDER2"
                                    v-model="NEXT_ORDER2"
                                    class="slt_white w100"
                                >
                                    <option value="" disabled selected>{{ $t('FIELD.NEXT.OF') }}</option>
                                    <option v-show="nextOrder2List.length > 0"
                                            v-for="item in nextOrder2List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.BOARD.NAME.E') }}<em class="txt_mandatory">*</em></th>
                    <td>
                        <input  type="text" class="text_input w100"
                                id="BOARD_NM_EN" name="BOARD_NM_EN"
                                :placeholder="$t('FIELD.ADMIN.BOARD.NAME.E')"
                                v-model="BOARD_NM_EN"
                                v-validation="{ groupId: 'basic' }" />
                    </td>
                    <th>{{ $t('FIELD.ADMIN.BOARD.NAME.LOCAL') }}<em class="txt_mandatory">*</em></th>
                    <td>
                        <input  type="text" class="text_input w100"
                                id="BOARD_NM" name="BOARD_NM"
                                :placeholder="$t('FIELD.ADMIN.BOARD.NAME.LOCAL')"
                                v-model="BOARD_NM"
                                v-validation="{ groupId: 'basic' }" />
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.BOARD.DESCRIPTION.E') }}</th>
                    <td colspan="3">
                        <textarea
                            class="text_textarea w100"
                            :placeholder="$t('FIELD.ADMIN.BOARD.DESCRIPTION.E')"
                            v-model="BOARD_DESC_EN"
                        ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.BOARD.DESCRIPTION.LOCAL') }}</th>
                    <td colspan="3">
                        <textarea
                            class="text_textarea w100"
                            :placeholder="$t('FIELD.ADMIN.BOARD.DESCRIPTION.LOCAL')"
                            v-model="BOARD_DESC"
                        ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.DISCAEDED.PERIOD') }}</th>
                    <td colspan="3">
                        <select class="slt_white input-58" v-model.number="DISCARDED_PERIOD">
                            <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                            <option v-show="discardedPreiodList.length > 0"
                                    v-for="item in discardedPreiodList"
                                    :key="item.code"
                                    :value="item.code"
                                    >{{item.codeName}}</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="btn_wrap_full topLine"></div>
        <!-- //detail_Basic Info -->

        <!--List Info-->
        <div class="sub_tit mt25">{{ $t('SUBTITLE.GLOBAL.LIST.INFO') }}</div>
        <!-- //List Info head -->
        <!-- detail_List Info -->
        <table class="create_table">
            <colgroup>
                <col width="13.5%">
                <col width="*">
                <col width="13.5%">
                <col width="*">
            </colgroup>
            <tbody>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.MAX.OF.COUNT') }}</th>
                    <td data-input-type="input">
                        <input type="number" class="text_input w100" :placeholder="$t('FIELD.ADMIN.MAX.OF.COUNT')" v-model.number="LIST_CNT" />
                    </td>
                    <td colspan="2"></td>
                </tr>
            </tbody>
        </table>
        <div class="btn_wrap_full topLine"></div>
        <!-- //List Info Info -->

        <!--Detail Info-->
        <div class="sub_tit mt25">{{ $t('SUBTITLE.GLOBAL.DETAIL.INFO') }}</div>
        <!-- //Detail Info head -->
        <!-- detail_Detail Info -->
        <table class="create_table">
            <colgroup>
                <col width="13.5%">
                <col width="*">
                <col width="13.5%">
                <col width="*">
            </colgroup>
            <tbody>
                <tr>
                    <th>{{ $t('FIELD.ADMIN.VERIFY') }}</th>
                    <td data-input-type="checkbox" colspan="3">
                        <label class="checkbox-wrap mr10">
                            <input type="checkbox" v-model="VERIFY_USE_YN"/>
                            <i class="check-icon"></i>
                            <em>{{ $t('FIELD.GLOBAL.USE') }}</em>
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="btn_wrap_full topLine"></div>
        <!-- //Detail Info -->

        <div class="btn_wrap_full">
            <a href="javascript:" class="btn_white size_full" @click="btnList">{{ $t('BUTTON.GLOBAL.LIST') }}</a>
            <div v-if="superUser === 'Y'" class="btn_right">
                <a href="javascript:" class="btn_blue" @click="btnSave">{{ $t('BUTTON.GLOBAL.SAVE') }}</a>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import resize                               from 'vue-resize-directive'
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';

// BoardManage save
const fetchBoardManageSave = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/knowledgeManager/boardManage/boardManageSave.skp`,
    qs.stringify(params), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name: 'BoardManageRegister',
    data() {
        return {
            pageTitle: '',
            myListMenuId: 'LEFT_0000000059',

            rhqCdList: [],              // RHQ List
            corpCdList: [],             // Subsidiary List
            boardType1List: [],         // Board Type List 1
            boardType2List: [],         // Board Type List 2
            nextOrder1List: [],         // Next Order List 1
            nextOrder2List: [],         // Next Order List 2
            discardedPreiodList: [],    // Discarded Period List

            // detail values
            BOARD_ID: '',
            BOARD_NM: '',
            BOARD_NM_EN: '',
            BOARD_DESC: '',
            BOARD_DESC_EN: '',
            BOARD_TYPE1: '',
            BOARD_TYPE2: '',
            BOARD_TYPE3: '',
            LIST_CNT: 10,
            ATTACH_YN: false,
            EVALUTION_YN: false,
            RECOMMEND_USE_YN: false,
            REG_USER_NO: '',
            REG_USER_NM: '',
            REG_DT: '',
            MODF_USER_NM: '',
            MODF_USER_NO: '',
            MODF_DT: '',
            SYSTEM_ID: '',
            MENU_ID: '',
            STATUS: '',
            RHQ_CD: '',
            CORP_NO: '',
            DISCARDED_PERIOD: '',
            VERIFY_USE_YN: false,
            NEXT_ORDER1: '',
            NEXT_ORDER2: '',
            ORDER_LEVEL: '',
            MENU_GROUP_CD: '',
            MENU_GROUP_DETAIL_CD: '',
        }
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            superUser: 'getSuperUserYn',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
        getLoginNo()            { return this.loginNo || ''; },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getSelBoardType1()      { return this.BOARD_TYPE1 || ''; },
        getSelBoardType2()      { return this.BOARD_TYPE2 || ''; },
        getIsDetail() {
            if(!SDLUtil.isNull(this.BOARD_ID) && this.BOARD_ID === this.boardId) {
                return true;

            } else {
                return false;
            }
        }
    },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
    },
    methods: {
        initLoad() {
            SDLUtil.showLoadingBar(true);
            // RHQ
            this.setRhqCd();
            // 게시판 타입 1 로드
            this.setBoardType1();
            // 기간
            this.setDiscardedPeriod();


            SDLUtil.showLoadingBar(false);
        },
        // Code combo list api
        async getCommonCodeList(categoryCode) {
            const codeResp = await api.getCommonCodeList(categoryCode);
            return codeResp;
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode, additionalValue = '') {
            additionalValue = additionalValue ? additionalValue : this.getUserCorpCd;
            const codeResp = await api.getComboList(categoryVal, categoryCode, additionalValue);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        setDiscardedPeriod() {
            let that = this;
            this.getCommonCodeList('DISCARDED_PERIOD')
                .then(data => {
                    this.discardedPreiodList = data, this.DISCARDED_PERIOD = '';
                });
        },
        setRhqCd() {
            let that = this;
            this.getCodeComboList(this.loginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data, this.RHQ_CD = '';
                    this.corpCdList = [], this.CORP_NO = '';
                });
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.corpCdList = [], this.CORP_NO = '';

            } else {
                this.getCodeComboList(comboValue, "SUB_AUTH_ACCESS_CD", this.getLoginNo).then(data => {
                    this.corpCdList = data, this.CORP_NO = '';
                });
            }
        },
        // 법인 코드 변경 이벤트
        changeCorpCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue === "") {
                this.boardType1List = [], this.BOARD_TYPE1 = '';
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else { // boardType1List
                this.getCodeComboList(comboValue, "BOARD_TYPE1_MENU").then(data => {
                    this.boardType1List = data, this.BOARD_TYPE1 = '';
                    this.boardType2List = [],   this.BOARD_TYPE2 = '';
                });
            }
        },
        // Board1 setting
        setBoardType1() {
            this.getCodeComboList(this.getUserCorpCd, "BOARD_TYPE1_MENU").then(data => {
                this.boardType1List = data, this.BOARD_TYPE1 = '';
            });
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id); // MENU_ID
            if (comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "NEXT_ORDER1").then(data => {
                    this.nextOrder1List = data, this.NEXT_ORDER1 = '';
                });

                this.getCodeComboList(comboValue, "BOARD_TYPE2_MENU", this.CORP_NO).then(data => {
                    this.boardType2List = data, this.BOARD_TYPE2 = '';
                    this.nextOrder2List = [],   this.NEXT_ORDER2 = '';
                });
            }
        },
        // Board2 combo change event => create Next Order2 combo list
        changeBoardType2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.nextOrder2List = [], this.NEXT_ORDER2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE3").then(data => {
                    this.nextOrder2List = data, this.NEXT_ORDER2 = '';
                });
            }
        },
        changeOrder(e) {
            this.BOARD_TYPE2 = '';
            this.NEXT_ORDER2 = '';
        },
        // Validation
        validBoardManager() {
            let that = this;
            return new Promise(function(resolve) {
                // Validation check 'groupId : basic'
                if(SDLUtil.onSubmitValidation('basic')) {
                    let validList = SDLUtil.getValidList(), validId = '';
                    for(let valid of validList) {
                        if(_.find(valid.el.classList, function(c){ return c === 'warning'; }) == 'warning') {
                            validId = valid.el.id;
                        }
                    };

                    return resolve({ result: false, validId: validId });
                };

                // Default parameters
                let params = {
                    result              : true,
                    BOARD_ID            : that.BOARD_ID,
                    BOARD_NM            : that.BOARD_NM,
                    BOARD_NM_EN         : that.BOARD_NM_EN,
                    BOARD_DESC          : that.BOARD_DESC,
                    BOARD_DESC_EN       : that.BOARD_DESC_EN,
                    BOARD_TYPE1         : that.BOARD_TYPE1,
                    BOARD_TYPE2         : that.BOARD_TYPE2,
                    BOARD_TYPE3         : that.BOARD_TYPE3,
                    LIST_CNT            : that.LIST_CNT,
                    ATTACH_YN           : StringUtil.boolToStr(that.ATTACH_YN),
                    EVALUTION_YN        : StringUtil.boolToStr(that.EVALUTION_YN),
                    RECOMMEND_USE_YN    : StringUtil.boolToStr(that.RECOMMEND_USE_YN),
                    RHQ_CD              : that.RHQ_CD,
                    CORP_NO             : that.CORP_NO,
                    DISCARDED_PERIOD    : that.DISCARDED_PERIOD,
                    VERIFY_USE_YN       : StringUtil.boolToStr(that.VERIFY_USE_YN),
                    NEXT_ORDER1         : that.NEXT_ORDER1,
                    NEXT_ORDER2         : that.NEXT_ORDER2,
                    ORDER_LEVEL         : that.ORDER_LEVEL,
                    MENU_GROUP_CD       : that.MENU_GROUP_CD,
                    MENU_GROUP_DETAIL_CD: that.MENU_GROUP_DETAIL_CD
                };

                Vue.$log.info('▶ BoardManageRegister.vue save contents =>', params);

                return resolve(params);
            });
        },
        // List 이동
        btnList() {
            this.$router.push({ name: 'BoardManageList' });
        },
        // Save
        async btnSave() {
            let that = this;
            await this.validBoardManager().then(params => {
                if(params.result) {
                    fetchBoardManageSave(params).then(res => {
                        let data = res.data;
                        SDLUtil.alert({
                            title: 'TITLE.POPUP.MESSAGE.DETAIL',
                            msg: data.msg,
                            onOkEvt: () => {
                                if(!SDLUtil.isNull(data.boardId)) {
                                    that.$router.push({ name: 'BoardManageDetail', query: { BOARD_ID: data.boardId } });
                                };
                            }
                        });
                    })
                    .catch(err => {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.alert(err);
                    });

                } else {
                    return document.getElementById(params.validId).focus();
                }
            });
        }
    },
    created() {
        Vue.$log.info('▶ BoardManageRegister.vue created.');
    },
    mounted() {
        this.$nextTick(() => {
            this.initLoad();
        });
    },
    beforeDestroy() {

    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/knowledgeManager/boardManage/BoardManageRegister.vue